import React, {Component} from "react";
import {Modal, Table} from "antd";
import util from "@util/index";
import moment from "moment";
import {
  queryIncCustomBusinessOregistapp,
  queryIncCustomBusinessSettled,
  queryIncCustomSettledSign,
} from "@api/incubator/custom";

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      settledList: [],
      loading: false,
    };
  }

  componentDidMount() {
    this.getIncCustomSettledSign();
  }

  getIncCustomBusinessSettled = () => {
    queryIncCustomBusinessSettled({
        customUuid: this.props.customUuid,
        incubatorUuid: this.props.incubatorUuid,
      })
      .then((res) => {
        if (res.statusCode === 200) {
          this.setState({
            settledList: res.data,
          });
        }
      });
  };

  getIncCustomSettledSign = () => {
    this.setState({ loading: true });
    queryIncCustomSettledSign({
        customUuid: this.props.customUuid,
        // incubatorUuid: this.props.incubatorUuid,
      })
      .then((res) => {
        if (res.statusCode === 200) {
          this.setState({
            settledList: res.data,
          });
        }
        this.setState({ loading: false });
      });
  };

  getIncCustomBusinessOregistapp = () => {
    queryIncCustomBusinessOregistapp({
        customUuid: this.props.customUuid,
        incubatorUuid: this.props.incubatorUuid,
      })
      .then((res) => {
        if (res.statusCode === 200) {
          this.setState({
            settledList: res.data,
          });
        }
      });
  };

  columns = () => {
    return [
      {
        title: "合同编号",
        dataIndex: "no",
        render: (text, record) => (
          <a onClick={() => this.props.changePage(record.businessUuid)}>
            {record.no}
          </a>
        ),
      },
      {
        title: "合同周期",
        dataIndex: "beginDate",
        render: (text, record) =>
          record.beginDate && record.endDate ? (
            <span>
              {moment.unix(record.beginDate / 1000).format("YYYY-MM-DD")}至
              {moment.unix(record.endDate / 1000).format("YYYY-MM-DD")}
            </span>
          ) : null,
      },
      {
        title: "交易类型",
        dataIndex: "type",
        key: "type",
        render: (text, record) => {
          return (
            <span>
              {record.price === 0 && record.indeposit === 0
                ? "免费注册"
                : "收费注册"}
            </span>
          );
        },
      },
      {
        title: "合同金额",
        dataIndex: "price",
        key: "price",
        render: (text, record) => {
          return <span>{text ? util.numberFormat(text) : ""}</span>;
        },
      },
      {
        title: "推荐人员",
        dataIndex: "recommend",
        key: "recommend",
        render: (text, record) => {
          return (
            <span>
              {text}
              <span style={{ marginLeft: "10px" }}>{record.recommendTel}</span>
            </span>
          );
        },
      },
    ];
  };

  onSelectChange = (record, selected) => {
    this.props.onOk(selected[0]);
  };

  handleOk = () => {
    if (this.props.selectedRowKeys[0]) {
      this.props.handleCancel(false);
    }
  };

  render() {
    const { visible, handleCancel, selectedRowKeys } = this.props;
    const { settledList, loading } = this.state;
    const rowSelection = {
      onChange: this.onSelectChange,
      type: "radio",
      selectedRowKeys,
    };
    return (
      <Modal
        width={880}
        visible={visible}
        title="基础孵化合同信息"
        onOk={this.handleOk}
        onCancel={() => handleCancel(false)}
      >
        <Table
          rowKey="uuid"
          loading={loading}
          columns={this.columns()}
          dataSource={settledList}
          pagination={{ pageSize: 5 }}
          rowSelection={rowSelection}
          onChange={this.onTableChange}
        />
      </Modal>
    );
  }
}

export default Index;



// WEBPACK FOOTER //
// ./src/components/incubator/contract/comm/ModalSettledList.js